"use strict";

var _interopRequireDefault = require("@babel/runtime-corejs3/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getBrowserInfo = void 0;
var _bowser = _interopRequireDefault(require("bowser"));
const getBrowserInfo = unsupportedBrowsers => {
  const browser = _bowser.default.getParser(window.navigator.userAgent);
  const satisfies = unsupportedBrowsers ? browser.satisfies(unsupportedBrowsers) : false;
  const {
    browser: browserInfo,
    os,
    platform
  } = browser.getResult();
  const resolution = `${window.screen.availWidth}x${window.screen.availHeight}`;
  return {
    name: browserInfo.name,
    version: browserInfo.version,
    os: os.name,
    osVersion: os.version,
    platform: platform.type,
    resolution,
    ...(unsupportedBrowsers ? {
      supported: !satisfies
    } : {})
  };
};
exports.getBrowserInfo = getBrowserInfo;